import {IEnvironment} from "./ienvironment";

export const environment:IEnvironment = {
  production: true
  ,applicationLogo: "/assets/images/logo-addo.png"
  ,applicationLogoTitle: "Path For Men in partnership with Discover and Change."
  ,applicationTitle: "Path For Men Intake System"
  ,token: "$2a$10$enEOgjOCulwD60710/fCI.xpDiJ9TfJhddr7k"
  ,stripePublicKey: "pk_live_Qrw8cLaapFskT6GTE4ozFXKg"
  ,stripeChargeName: "Discover and Change"
  ,features: {
    "client.add": true
    // can you add/edit see the list of assessments on the assessment admin page.
    ,"assessments.manage": true
    ,"assessments.reports.manage": true
    // does the navigation link to the assessments admin show up
    ,"admin.assessments.navigation": true
    // the link back to addo's home page.
    ,"addo.dashboard.admin": true
    // can batteries be added, displayed, managed, etc.
    ,"assessments.battery.manage": true
    // does the client edit assessment email template display
    ,"assessments.manage.emailtemplate": true
    ,"wordpress.auth.check": false
    ,"admin.shop": true
    ,"assessments.tokens.enabled": true
  } 
  ,useAddoReports: true
  ,apiURL: "https://assessment-api.pathformen.com/api/v1/"
  ,supportEmail: "hello@pathformen.com"
  ,supportPhone: "(855) 229-2336"
  ,skinClasses: ['addo-skin','addo-blue-skin']
  ,navBarClass: 'navbar-light'
  ,reportHeaderImgURL: "/assets/images/addo-report-header1.png"
  ,partners: ['discoverandchange']
  ,disabledAssessments: []
  ,copyrightURL: "https://pathformen.com/"
  ,copyrightTitle: "PathForMen"
  ,awsCognitoConfig: {
    awsCognitoRegion: 'us-east-1',
    userPool: {
      userPoolsId:"us-east-1_4McRrU0Wx",
      webClientId:"7c2ijpct85se7ddc1d9803bf6"
    }
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts